module.exports = __webpack_public_path__ + "img/banner.133bab99.png";